const TYPE = {
    NAME_CCONNECT_TERMINAL: "Credit Card On Terminal (CardConnect)",
    NAME_CCONNECT_KEY_IN: "Credit Card Keyed-in (CardConnect)",
    NAME_CCONNECT_CARD_ON_FILE: "Credit Card On File (CardConnect)",
    NAME_STRIPE_TERMINAL: "Credit Card On Terminal (Stripe)",
    NAME_STRIPE_KEY_IN: "Credit Card Keyed-in (Stripe)",
    NAME_STRIPE_CARD_ON_FILE: "Credit Card On File (Stripe)",
    NAME_BNPL_SUNBIT: "Buy Now,Pay Later (Sunbit)"
};

const STATUS = {
    ACTIVE: 1,
    INACTIVE: 2,
    SUSPENDED: 3
};

export default {
    TYPE,
    STATUS
};
